import { CommonModule, DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConsultationsService } from '../../../../core/services/consultation/consultations.service';
import { FormsModule, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { PatientsService } from '../../../../core/services/patient/patients.service';
import { CaseStatus } from '../../../../../enums/case-status.enum';
import { SurveyListModel } from '../../../../core/models/survey/survey-list.model';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { TranslateModule } from '@ngx-translate/core';
import { DiabetesFormsComponent } from '../../../components/diabetes-forms/diabetes-forms.component';
@Component({
  selector: 'app-patient-case-card',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SelectDropDownModule,
    TranslateModule,
    DiabetesFormsComponent,
  ],
  templateUrl: './patient-case-card.component.html',
  styleUrl: './patient-case-card.component.scss',
  providers: [DatePipe],
})
export class PatientCaseCardComponent implements OnInit {
  caseStatus = CaseStatus;
  preparationForm: FormGroup;
  newPatientId: string = '';
  caseId: string = '';
  patientId: string = '';
  caseDetailHeader = {
    name: '',
    lastName: '',
    pidNo: '',
    gender: '',
    age: null as any,
    birthDate: '',
    patientStatus: 0,
    createdDate: '',
    createdBy: '',
    caseId: '',
    customerCode: '',
    bodyLocation: '',
  };
  selectedIndex: number = 0;
  today: number = Date.now();
  isDragOver = false;
  maxDate: string = '';
  minDate: string = '';
  surveys: SurveyListModel[] = [];

  constructor(
    private route: ActivatedRoute,
    private consultationsService: ConsultationsService,
    private patientsService: PatientsService
  ) {}

  ngOnInit() {
    // Create new case
    this.route.paramMap.subscribe((params) => {
      this.newPatientId = params.get('id') || '';
      console.log('New Patient ID:', this.newPatientId);
      if (this.newPatientId) {
        this.getPatientDetail(this.newPatientId);
      }
    });

    // Add a case from a certain case
    this.route.queryParamMap.subscribe((params) => {
      this.caseId = params.get('id') || '';
      if (this.caseId) {
        this.getConsultationDetail(this.caseId, 'detail');
      }
    });
  }

  getPatientDetail(id: string) {
    if (id) {
      this.patientsService.patientDeteail(id).subscribe({
        next: (res) => {
          this.caseDetailHeader.name = res.name;
          this.caseDetailHeader.lastName = res.lastName;
          this.caseDetailHeader.gender = res.gender;
          this.caseDetailHeader.age = res.age;
          this.caseDetailHeader.birthDate = res.birthDate;
          this.caseDetailHeader.createdDate = res.createdDate;
          this.caseDetailHeader.pidNo = res.pidNo;
          this.caseDetailHeader.customerCode = res.customerCode;
        },
      });
    }
  }

  getConsultationDetail(id: string, type: string) {
    if (id) {
      this.consultationsService
        .consultationDetailByPatientRecordCaseId(id)
        .subscribe({
          next: (res) => {
            this.caseDetailHeader.name = res.name;
            this.caseDetailHeader.lastName = res.lastName;
            this.caseDetailHeader.gender = res.gender;
            this.caseDetailHeader.age = res.age;
            this.caseDetailHeader.birthDate = res.birthDate;
            this.caseDetailHeader.createdDate = res.createdDate;
            this.caseDetailHeader.customerCode = res.customerCode;
          },
        });
    }
  }

  getPatientRecordCaseDetail(id: string) {
    if (id) {
      this.patientsService.patientRecordCaseDetail(id).subscribe({
        next: (res) => {
          this.preparationForm.patchValue({
            medications: res.medication.id,
            additionalInformation: res.additionalInformation,
          });
        },
      });
    }
  }
}
